<template>

  <div class="row">
      <loader v-if="!loaded"  class="table-loader"></loader>
      <div class="col-md-9">

        <line-chart class="row" v-bind:datasets="chartData"
                    :chart-id="'chartForStimulChart' + stageId + category && category.id ? category.id : ''"
                    :withLegend="true"
                    :showLegend="false"
                    v-on:generated="setLegend"
                    :scale-label="'protocol.countSamplesAxes' | trans"
                    :stage-info="stageId"
                    :category-info="category"
                    v-bind:list-chart-date="chartDatasetsForStimul.labels"
                    v-bind:many-chart="chartDatasetsForStimul.chartData.length > 1"
                    v-bind:show-legend="chartDatasetsForStimul.chartData.length > 1"
                    v-bind:y-axes-begin-at-zero="true"
                    v-bind:vertical-line-point=changesLine
                    v-bind:linedatasets="trendLinePoint"
                    v-on:popup-show="popupShow"
                    :persentMax=persentMax
                    :labelText="'%'"
                    :is-mobile="isMobile"
                    :aspect-ratio=false
                    :height="340"
                    :width=null
        />


      </div>
      <div class="mt-3 col-md-3" v-if="chartDatasetsForStimul.chartData.length === 1 && labelsActiveLength > 2">
        <mdc-switch v-model="levelLineChecked">{{ 'protocol.levelLine' | trans }}</mdc-switch>
        <mdc-switch v-model="trendLineChecked">{{ 'protocol.trendLine' | trans }}</mdc-switch>
        <mdc-switch v-model="ScatterLineChecked">{{ 'protocol.scatterLine' | trans }}</mdc-switch>
      </div>
      <div class="mt-3 col-md-3" v-if="chartDatasetsForStimul.chartData.length !== 1">
        <div class="legend-con" v-html="message">

        </div>
      </div>
      <div class="col-12">
        <h4 class="chart__title mb-3">
          {{ 'protocol.chart_properties_percent' | trans }}
          <span v-for="(stimul, indexStim) in chartData">{{stimul.label}}<span
              v-if="indexStim < chartData.length -1">, </span></span>. <span v-if="teachingMethod == 9">{{stage.description}}</span>
        </h4>
      </div>

    <div v-if="isModalVisible && !isPecsWithItems">

      <chart-popup :visible="isModalVisible"
                   :isPecsWithoutDiscrimination="false"
                   :isPecs="false"
                   :isPecsWithDiscrimination="isPecsWithDiscrimination"
                   :isPecsWithItems="isPecsWithItems"
                   :isStageChain="true"
                   chartType="1"
                   :stimulId="chosenStimul[0].id"
                   v-on:close="onClose"
                   :stage-id="selectedStageId"
                   :category-info="categoryInfo"
                   :graphTitle="'protocol.stimulus_mastering_chart' | trans"
                   :protocolId="protocolId"
                   :dataPoint="dataPoint">
      </chart-popup>

    </div>

    <div v-if="isModalVisible && isPecsWithItems">

      <chart-popup-table :visible="isModalVisible"
                   :isPecsWithItems="isPecsWithItems"
                   chartType="1"
                   :stimulId="chosenStimul[0].id"
                   v-on:close="onClose"
                   :category-info="categoryInfo"
                   :graphTitle="'protocol.stimulus_mastering_chart' | trans"
                   :protocolId="protocolId"
                   :dataPoint="dataPoint">
      </chart-popup-table>

    </div>


  </div>

</template>

<script>
  import {LineChartDataset, LineChart} from '../../../common/chart';
  import ChartPopup from '../../dashboardParent/components/ChartPopup';
  import ChartPopupTable from '../../dashboardParent/components/ChartPopupTable';
  import forEach from 'lodash/forEach';
  import moment from 'moment';
  import Loader from '../../loader/components/Loader';
  import {mapGetters} from 'vuex';
  import minBy from 'lodash/minBy';
  import maxBy from 'lodash/maxBy';
  import filter from 'lodash/filter';
  import startsWith from 'lodash/startsWith';
  import {typeProtocol} from '../../../common/mixins/typeProtocol';
  import lang from '../../../lang/translator';

  export default {
    props: ['chartData', 'chartDatasetsForStimul', 'changesLine', 'category', 'loaded', 'chosenStimul', 'protocolId', 'stage', 'teachingMethod'],
    components: {
      LineChartDataset, LineChart, ChartPopup, Loader, ChartPopupTable
    },
    data() {
      return {
        message: '',
        selectedStageId: null,
        dataPoint: null,
        type: null,
        isModalVisible: false,
        persentMax: true,
        levelLineChecked: false,
        trendLineChecked: false,
        ScatterLineChecked: false,
        trendLinePoint: null,
        categoryInfo: null

      }
    },
    mixins: [typeProtocol],
    computed:{
      ...mapGetters('mobile', [
        'isMobile',
      ]),

      labelsActiveLength(){
        return filter(this.chartDatasetsForStimul.labels, label =>{
          return !startsWith(label, lang.get('protocol.changes'))
        }).length;
      },

      stageId(){
        return this.stage ? this.stage.id : null;
      }
    },
    created() {
    },
    methods: {

      setLegend (html) {
        this.message = html
      },

      popupShow(data,stageId, datasetIndex, categoryInfo ){

        if(this.chartDatasetsForStimul.chartData.length === 1){

          this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix();
          this.selectedStageId = stageId;
          this.categoryInfo = categoryInfo;
          this.isModalVisible = true;

        }


      },

      onClose() {
        this.isModalVisible = false;
      },

      trendLine(item) {
        let SumOfPowX = 0, SumOfX = 0, n = item.length, SumOfXY = 0, SumOfY = 0;

        for (let i = 0; i < n; i++) {
          SumOfPowX += (i + 1) * (i + 1);
          SumOfX += (i + 1);
          SumOfXY += (i + 1) * item[i].y;
          SumOfY += item[i].y;
        }
        let det = SumOfPowX * n - Math.pow(SumOfX, 2);
        let a = (SumOfXY * n - SumOfX * SumOfY) / det;
        let b = (SumOfY - a * SumOfX) / n;

        let first = a + b;
        let last = a * n + b;

        let data = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: first,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n - 1].x,
            y: last,
          },
        ];

        let dataset = new LineChartDataset({
          data,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        return dataset

      },

      levelLine(item) {
        let n = item.length, SumOfY = 0, y = 0;

        forEach(item, point => {
          SumOfY += point.y;
        });

        y = SumOfY / n;

        let data = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: y,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n - 1].x,
            y: y,
          },
        ];

        let dataset = new LineChartDataset({
          data,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        return dataset

      },

      scatterLine(item) {
        let n = item.length, SumOfY = 0, y = 0;

        let min = minBy(item, function (o) {
          return o.y;
        });
        let max = maxBy(item, function (o) {
          return o.y;
        });


        let dataMin = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: min,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n - 1].x,
            y: min,
          },
        ];

        let dataMax = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: max,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n - 1].x,
            y: max,
          },
        ];

        let datasetMin = new LineChartDataset({
          data: dataMin,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        let datasetMax = new LineChartDataset({
          data: dataMax,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        let dataset = [datasetMin, datasetMax]

        return dataset

      },


      fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {

        let data = [], trendPointIndex = [], trendPoint = [], i = 0;
        let array = [];

        forEach(item, (point, index) => {

          if (point.isImportant) {
            trendPoint.push(
                array
            );
            array = [];
            trendPointIndex.push(index)
          } else {
            if (!point.isChanged) {
              array.push(point);
            }
            if (index == item.length - 1) {
              trendPoint.push(
                  array
              );
            }
          }

        });
        let dataset = [];

        if (trendLine) {
          forEach(trendPoint, (point) => {
            if (point.length > 2) {
              dataset.push(this.trendLine(point));
            }
          });
        }
        if (levelLine) {
          forEach(trendPoint, (point) => {
            if (point.length > 2) {
              dataset.push(this.levelLine(point));
            }
          });
        }
        if (scatterLine) {
          forEach(trendPoint, (point) => {
            if (point.length > 2) {
              dataset.push(this.scatterLine(point)[0]);
              dataset.push(this.scatterLine(point)[1]);
            }
          });
        }

        //this.isChangeStimuli = false;

        return dataset
      },
    },
    watch: {
      levelLineChecked(newValue) {
        this.isChangeStimuli = true;
        console.info(this.chartData)

        if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
          this.trendLinePoint = this.fetchDatasetLineTrend(this.chartData[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
        } else {
          this.trendLinePoint = null;
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);
      },
      trendLineChecked(newValue) {
        this.isChangeStimuli = true;
        if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
          this.trendLinePoint = this.fetchDatasetLineTrend(this.chartData[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
        } else {
          this.trendLinePoint = null;
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);

      },
      ScatterLineChecked(newValue) {
        this.isChangeStimuli = true;
        if (this.trendLineChecked || this.levelLineChecked || this.ScatterLineChecked) {
          this.trendLinePoint = this.fetchDatasetLineTrend(this.chartData[0].data, this.trendLineChecked, this.levelLineChecked, this.ScatterLineChecked);
        } else {
          this.trendLinePoint = null;
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);
      },


    },
  }
</script>


// WEBPACK FOOTER //
// src/modules/chart/component/ChartForStimul.vue